
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class StudySystem extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
